import type { DirectiveDescriptor } from '@mdxeditor/editor';
import { widgetRegistry } from '@rmint/widgets/registry';
import { ReadOnlyWidget } from '../widget-renderer/ReadOnlyWidget';
import { bracketLabelOf } from '@rmint/core/directives/bracket-label';

// MDXEditor's DirectiveDescriptor shape:
//   name: string                      // matches mdast `name` (we use 'widget')
//   testNode(node): boolean           // distinguishes per bracket label
//   attributes: string[]              // attribute allowlist (we accept any)
//   hasChildren: boolean
//   Editor: React component
//
// We emit one descriptor per widget so MDXEditor renders the matching
// component for each widget directive (the form produced by
// normalizeAgentMarkdown applied upstream — see Task 14).
//
// Directive node type: corpus content produces a *textDirective* after
// normalizeAgentMarkdown rewrites `:::widget[X]{...}:::` to `:widget[X]{...}`
// (single colon = inline directive). We also accept `leafDirective` for
// the rarer block form (`::widget[X]{...}` on its own line). The existing
// chat path mirrors this — see apps/web/src/components/canvas/markdown-renderer.tsx.
//
// Bracket-label location: both directive types store the [name] payload as
// `node.children[0].value` (a text node), NOT in `attributes.id`.

export const widgetDirectiveDescriptors: DirectiveDescriptor<any>[] =
  Object.keys(widgetRegistry).map((widgetName) => ({
    name: 'widget',
    testNode: (node: any) =>
      (node?.type === 'textDirective' || node?.type === 'leafDirective') &&
      node?.name === 'widget' &&
      bracketLabelOf(node) === widgetName,
    attributes: [],
    hasChildren: false,
    Editor: ({ mdastNode }: any) => (
      <ReadOnlyWidget
        name={widgetName}
        attrs={(mdastNode?.attributes as Record<string, string>) ?? {}}
      />
    ),
  }));
